module.exports = __webpack_public_path__ + "images/monogamist-7a712838b16e252e3645a1751ea69f38.png";